import { DataProviderProcessor } from '@sitecore-search/data';
import WidgetsConfig from './widgetsConfig.js';
export default class WidgetsConfigDataProviderStrategy extends DataProviderProcessor {
    processResponse(response) {
        response.widgets?.forEach(({ rfk_id: rfkId, type, variation_id: variationId, used_in: usedIn }) => {
            WidgetsConfig.setMetadata(rfkId, { rfkId, type, variationId, usedIn });
        });
        return response;
    }
}
